import React, { useState, useEffect } from "react";
import { useAuth } from "../Context/store/context";
import { useSelector } from "react-redux";
import "./Navbar.css";
import { Dropdown } from "bootstrap"; //important dont delete//
import Icon from "../Icon";
import { IconMenu2, IconLogout, IconKeyFilled } from '@tabler/icons-react'
import ChangePassword from "./ChangePassword";

export default function Navbar() {
  const { logoutuser, showLoader, hideLoader, ShowPasswordModal, title, pageIcon } = useAuth();
  const [ProfileImgurl, setProfileImgurl] = useState("/images/user3.png");
  const [Title, setTitle] = useState(undefined);
  const [icon, setIcon] = useState(undefined);
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const [showChangePassword, setShowChangePassword] = useState(false);

  const handletoggle = () => {
    const htmlElement = document.documentElement;

    htmlElement.classList.add("layout-menu-expanded");
    htmlElement.classList.add("light-style");
    htmlElement.classList.add("layout-navbar-fixed");
    htmlElement.classList.add("layout-menu-fixed");
    htmlElement.classList.remove("layout-menu-collapsed");
    htmlElement.classList.remove("layout-menu-hover");
  };

  const handlelogout = () => {
    showLoader();
    logoutuser();
    hideLoader();
  };

  const handlechangepassword = () => {
    setShowChangePassword(true);
  };

  const closeChangePasswordHandler = () => {
    setShowChangePassword(false);
  }

  useEffect(() => {
    const htmlElement = document.documentElement;
    htmlElement.classList.add("light-style");

    if (userDetails) {
      if (userDetails.profileImage) {
        setProfileImgurl(userDetails.profileImage);
      }
    }
  }, [userDetails]);

  useEffect(() => {
    if (title) {
      setTitle(title);
    }
  }, [title]);

  useEffect(() => {
    if (pageIcon)
      setIcon(pageIcon);
  }, [pageIcon]);

  return (
    <>
      <nav
        className="d-print-none layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
        id="layout-navbar"
      >
        <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
          <a onClick={handletoggle} className="nav-item nav-link px-0 me-xl-4">
            <IconMenu2 />
          </a>
        </div>

        <div
          className="navbar-nav-right d-flex align-items-center"
          id="navbar-collapse"
        >
          <div className="navbar-nav mt-0 align-items-center">
            <div className="d-flex">
              <div className="avatar flex-shrink-0 me-2" style={{ cursor: "default" }}>
                <span className="avatar-initial rounded-circle bg-label-primary">
                  <Icon name={icon} size={24} className="nav-icon" />
                </span>
              </div>
              <div>
                <h5 className="mb-0 mt-1 text-nowrap text-dark">{Title}</h5>
              </div>
            </div>
          </div>

          <ul className="navbar-nav flex-row align-items-center ms-auto">
            <li className="nav-item navbar-dropdown dropdown-user dropdown">
              <a
                className="nav-link dropdown-toggle hide-arrow"
                data-bs-toggle="dropdown"
              >
                <div className="avatar">
                  <img
                    src={ProfileImgurl}
                    alt="img"
                    className=" rounded-circle"
                  />
                </div>
              </a>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <a className="dropdown-item" href="/profile">
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar">
                          <img
                            src={ProfileImgurl}
                            alt="img"
                            className=" rounded-circle"
                          />
                        </div>
                      </div>
                      {(userDetails) && (
                        <div className="flex-grow-1">
                          <span className="fw-semibold d-block">
                            {userDetails.firstName + " " + userDetails.lastName}
                          </span>
                          <span className="text-muted">
                            {userDetails.contactNo}
                          </span>
                        </div>
                      )}
                    </div>
                  </a>
                </li>
                <li>
                  <div className="dropdown-divider"></div>
                </li>
                <li>
                  <a className="dropdown-item cursor-pointer" onClick={handlechangepassword}>
                    <IconKeyFilled className="me-2" size={18} />
                    <span className="align-middle">Change Password</span>
                  </a>
                </li>
                <li>
                  <a className="dropdown-item  cursor-pointer" onClick={handlelogout}>
                    <IconLogout className="me-2" size={18} />
                    <span className="align-middle">Log Out</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
      {
        showChangePassword && (
          <div>
            <ChangePassword
              onClose={closeChangePasswordHandler}
            />
          </div>
        )
      }
    </>
  );
}
